module.exports = Mustache;


//////////////////
// WEBPACK FOOTER
// external "Mustache"
// module id = 548
// module chunks = 2